// extracted by mini-css-extract-plugin
module.exports = {"Detail_Sections_Top_Action_Bar":"DetailSectionsTopActionBar_Detail_Sections_Top_Action_Bar__36Zbc"};